import { loading } from 'State/actions';
import * as types from './types';

export const fetchCalendars = id => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SCHOOL_CALENDAR_LIST_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric('SchoolCalendar');
      dispatch(fetchSuccess(response.data.Data));
    } catch (error) {
      dispatch(fetchError(error));
    }

    dispatch(loading(types.SCHOOL_CALENDAR_LIST_FETCHING, false));
  };
};

const fetchSuccess = data => {
  return {
    type: types.SCHOOL_CALENDAR_LIST_FETCH,
    payload: data,
  };
};

const fetchError = error => {
  return {
    type: types.SCHOOL_CALENDAR_LIST_FETCH_ERROR,
    payload: error,
  };
};



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/state/calendarList/actions.js